import Vue from 'vue';

import InquiryForm from "./InquiryForm";

Vue.component('brku-inquiry-form', InquiryForm)
